import { BaseQueryBuilder } from "./base-query-builder";
import { LookupClientService } from "../../../../../../../../services/lookups/lookup-client.service";
import { CustomerService } from "../../../../../../../../services/modules/customer-client.service";
import { ManageRightShipUsersClientService } from "../../../../../../../../services/modules/righship-qi-manage-users.service";
import { autoinject, transient } from "aurelia-framework";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

class VesselVetQueryFilter {
    vetting: number;
}

@autoinject
@transient()
export class VettingrulevesselvetQueryBuilder  extends BaseQueryBuilder<VesselVetQueryFilter>{

    constructor(lookupService: LookupClientService, customerService: CustomerService,
        manageRightShipUsersClientService: ManageRightShipUsersClientService, protected configService: ConfigService) {
        super(lookupService, customerService, manageRightShipUsersClientService, configService);
    }
    
    itemSource: { name: string; value: number; }[] = [
        {name: "Never been vetted by Rightship", value: 1},
        {name: "Never been vetted for this business unit", value: 2},
        {name: "Never been vetted for this customer", value: 3}
    ];
}